import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "./utils/pwa";
import { initPostHog } from "./utils/posthog"; // R14: npm package for SRI compliance

// Initialize PostHog analytics
initPostHog();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  console.log('[PWA] Service worker registration skipped in development mode');
}
